import React, { useState, useRef } from 'react';
import styled from 'styled-components';
import { buttonFavorite, searchFavorite } from '../../services/firebase';
import Badge from '@material-ui/core/Badge';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import { makeStyles } from '@material-ui/core/styles';
import { Edit } from 'react-feather';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { CircularProgress, TextField } from '@material-ui/core';
import { toast } from 'react-toastify';
import { OverlayTrigger } from 'react-bootstrap';
import ReactTooltip from 'react-tooltip';
import { glassPanelBase, mutedPanelTitle, glassPillButtonBase } from '../ui/mysites';
import { commonColors } from '../ui/commonStyles';

const RecordOptionsContainer = styled.div`
  max-width: 22rem;
  border-radius: 1.25rem;
  padding: 0.5rem 0.75rem;
  position: relative;
  overflow-y: hidden;
  ${glassPanelBase};

  .panel-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 0.25rem;
  }

  h2 {
    flex: 1;
    min-width: 0;
    margin: 0 0 12px;
    font-size: 1.5rem;
    ${mutedPanelTitle};
  }

  .options-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    overflow-y: auto;
    padding-right: 10px;

    &::-webkit-scrollbar {
      width: 4px;
    }
    &::-webkit-scrollbar-track {
      background: #0042;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #fff;
      border-radius: 20px;
    }
  }

  .options {
    column-count: 2;

    .MuiBadge-root {
      width: 100%;
    }

    .MuiBadge-badge {
      cursor: pointer;
    }
  }

  .close-button {

    color: #fff;
    font-size: 1.5rem;
  }

  .style-button {
    background: rgba(10, 15, 23, 0.72);
    border: 1px solid rgba(148, 163, 184, 0.35);
    color: #9fb3cb;
    border-radius: 999px;
  }
`;

const FavoritesOptionsButton = styled.button<{ isSelected: boolean }>`
  width: 100%;
  padding: 6px 10px;
  font-weight: 500;
  font-size: 14px;
  line-height: 1.2;
  font-family: 'DM Sans', -apple-system, sans-serif;
  text-align: left;
  ${glassPillButtonBase};

  ${(props) => (props.isSelected ?
    `
      background: #fff;
      color: #0f172a;
      border-color: #fff;
    ` : '')};
`;

const OptionsButtonsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.8rem;
`;

const CloseButton = styled.div`
 display: flex;
 align-items: center;
 justify-content: space-between;
`;

interface IMyTundraFavoriteButtons {
  selectedRecord: any;
  onCloseFacility: () => void;
  setSelectedRecordOption: any;
  setShowCustomizeButtons: any;
  setIframeUrl: any;
  optionsList: any;
  setOptionsList: any;
  setMapType: any;
  mapType: any;
  resetMap: any;
  setcopySnackbar: any;
  setIframeSpinner: any;
  selectedButton: string | undefined;
  setSelectedButton: (name: string | undefined) => void;
}

const MyTundraFavoriteButtons: React.FC<IMyTundraFavoriteButtons> = ({
  selectedRecord,
  onCloseFacility,
  setSelectedRecordOption,
  setShowCustomizeButtons,
  setIframeUrl,
  optionsList,
  setOptionsList,
  mapType,
  setMapType,
  resetMap,
  setcopySnackbar,
  setIframeSpinner,
  selectedButton,
  setSelectedButton,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isEditable, setIsEditable] = useState<boolean>(false);
  const [currentButton, setCurrentButton] = useState<number>(0);
  const [showDisplayNameModal, setShowDisplayNameModal] = useState<boolean>(false);
  const buttonRef = useRef(null);
  const options = ['+ Add Buttons', 'Edit Buttons'];
  const [titleheight, setTitleHeight] = useState(0);
  const titleRef: any = useRef(null);
  const [displayName, setDisplayName] =  useState(selectedRecord.displayName);
  const [displayNameInput, setDisplayNameInput] =  useState(selectedRecord.displayName);
  const [isDisplayNameUpdating, setIsDisplayNameUpdating] =  useState(false);

  // optionsList = optionsList.map((elem: any) => {
  //   if(elem.name === 'Air Emissions System' && selectedRecord.entityNumber !== 'RN100218841') {
  //     return null;
  //   } else {
  //     return elem;
  //   }
  // }).filter((x: any) => x);

  React.useEffect(() => {
    const titleElHeight = (titleRef && titleRef.current && titleRef.current.clientHeight) ? titleRef.current.clientHeight : 0;
    setTitleHeight(titleElHeight);
  }, [titleRef]);

  const removeButtonFavorite = async (option: any) => {
    const list = optionsList.filter((listOption: any) => listOption.buttonId !== option.buttonId);
    setOptionsList(list);

    await buttonFavorite({
      actionType: 'remove',
      record: option
    });
  };

  const useStyles = makeStyles({
    label: {
      textTransform: 'capitalize',
    },
    paper: { width: '35%' },
    menuPaper: {
      background: 'rgba(7, 12, 20, 0.94)',
      border: `1px solid ${commonColors.borderSoft}`,
      boxShadow: '0 12px 28px rgba(0, 0, 0, 0.35)',
      backdropFilter: 'blur(8px)',
      borderRadius: '10px',
      marginTop: '4px',
    },
    menuList: {
      padding: '4px',
    },
    menuItem: {
      color: commonColors.textPrimary,
      borderRadius: '8px',
      fontSize: '0.95rem',
      '&:hover': {
        background: 'rgba(52, 211, 153, 0.2)',
      },
      '&$selected': {
        background: 'rgba(52, 211, 153, 0.25)',
        color: commonColors.textPrimary,
      },
    },
    selected: {},
  });
  const classes = useStyles();

  const getButtonDropDown = () => {
    const onClickHandlers = [() => {
      setIsEditable(false);
      setShowCustomizeButtons(true);
      setSelectedRecordOption('');
      setIframeUrl('');
    }, () => {
      if(isEditable) {
        setCurrentButton(0);
      }
      setIsEditable((prevValue) => !prevValue);
    }];

    const onClickHandler = (index: number) => {
      onClickHandlers[index]();
    };

    const handleMenuItemClick = (index: number) => {
      setIsOpen(false);
      setCurrentButton(index);
      onClickHandler(index);
    };

    const buttonStyles = {
      borderRadius: '999px',
      border: '1px solid rgba(148, 163, 184, 0.35)',
      color: '#94a3b8',
      background: 'rgba(10, 10, 12, 0.62)',
      padding: '4px 10px',
      fontFamily: '\'DM Sans\', -apple-system, sans-serif',
      fontWeight: 500,
    };

    return (
      <>
        <ButtonGroup variant="contained" color="primary" ref={buttonRef} aria-label="split button">
          <Button style={{...buttonStyles, borderRight: '0.5rem'}} classes={{label: classes.label}}  onClick={() => onClickHandler(currentButton)}>
            {currentButton === 1 && isEditable ? 'Disable Edit' : options[currentButton] }
          </Button>
          <Button
            style={buttonStyles}
            onClick={() => setIsOpen((prevOpen) => !prevOpen)}
          >
            <ArrowDropDownIcon />
          </Button>
        </ButtonGroup>
        <Popper
          open={isOpen}
          role={undefined}
          anchorEl={buttonRef.current}
          placement="bottom"
          transition
          disablePortal
        >
          {({ TransitionProps }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin: 'center bottom',
              }}
            >
              <Paper className={classes.menuPaper}>
                <ClickAwayListener onClickAway={() => setIsOpen(false)}>
                  <MenuList id="split-button-menu" className={classes.menuList}>
                    {options.map((option, index) => (
                      <MenuItem
                        key={option}
                        classes={{ root: classes.menuItem, selected: classes.selected }}
                        selected={index === currentButton}
                        onClick={() => handleMenuItemClick(index)}
                      >
                        {option}
                      </MenuItem>
                    )).filter((key, index) => index !== currentButton)}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </>);
  };

  const resetMapHandler = (e: any) => {
    if(mapType) {
      resetMap(e);
      setMapType('');
    }
  };

  const onDisplayNameInputChange = (e: any) => {
    setDisplayNameInput(e.target.value);
  };

  const favoritesFn = async ({type, bodyData}: {type: string, bodyData?: any}) => {
    try {
      const requestBody: any = {
        type,
      };
      if(type === 'update_displayname') {
        requestBody.record = bodyData;
      }
      if(type === 'update_displayname') {
        setIsDisplayNameUpdating(true);
        const result: any = await searchFavorite(requestBody);
        setIsDisplayNameUpdating(false);
        toast.success(`Display Name Updated SuccessFully.`);
        if(result.data) {
          setDisplayName(result.data.displayName);
          selectedRecord.displayName = result.data.displayName;
        }
      }
      setShowDisplayNameModal(false);
    } catch (error) {
        setIsDisplayNameUpdating(false);
        toast.error(`Error while updating site display name.`);
      }

  };

  const resetHandler =() => {
    setDisplayNameInput('');
  };

  const CloseHandler =() => {
    setShowDisplayNameModal(false);
    setDisplayName(selectedRecord.displayName);
  };

  const onFavoriteButtonClick = (e: any, option: any) => {
    resetMapHandler(e);
    setShowCustomizeButtons(false);
    setSelectedRecordOption('');
    setIframeUrl(option.href);
    setSelectedButton(option.name);
    setIframeSpinner(true);

    if(option.buttonId === 29 || option.buttonId === 12) {
      // Copy for EJ Screen
      setcopySnackbar(true);
    } else {
      setcopySnackbar(false);
    }
  };

  return (
    <RecordOptionsContainer>
    <div className="panel-header">
      <h2 ref={titleRef}>{displayName ? displayName : selectedRecord.entityName }
      <OverlayTrigger
            overlay={<ReactTooltip place="bottom" effect="solid" />}
          >
            <Button data-tip="Edit Entity Display Name" style={{color: 'white' }} onClick={() => setShowDisplayNameModal(true)}>
              <Edit />
            </Button>
          </OverlayTrigger>
      </h2>
      <OverlayTrigger
            overlay={<ReactTooltip place="bottom" effect="solid" />}
          >
            <Button
              data-tip="Close"
              className="close-button"
              onClick={() => {
                onCloseFacility();
              }}
            >
              ×
            </Button>
          </OverlayTrigger>
    </div>

    <Dialog
        open={showDisplayNameModal}
        onClose={() => setShowDisplayNameModal(false)}
        classes={{ paper: classes.paper}}
      >
      <CloseButton>
          <DialogTitle>Display Name</DialogTitle>
          <div>
          <Button  style={{fontSize: 'large'}} onClick={() => {CloseHandler();}}>X</Button>
          </div>
      </CloseButton>
          <DialogContent>
            <TextField
              fullWidth
              disabled
              id="default-name"
              label="Default Name"
              name="adddefaultName"
              value={selectedRecord.entityName}
              />
            <br /><br />
            <TextField
              autoFocus
              fullWidth
              id="display-name"
              label="Display Name"
              name="adddisplayname"
              value={displayNameInput}
              onChange={onDisplayNameInputChange}
            />
          </DialogContent>
          <DialogActions>
             <Button
              variant="contained"
              onClick={resetHandler}
              color="primary"
              style={{visibility: displayName ? 'visible' : 'hidden'}}
            >
              Reset
            </Button>
            <Button
              disabled={isDisplayNameUpdating}
              variant="contained"
              onClick={() => {
                favoritesFn({type: 'update_displayname', bodyData: {
                  contentId:selectedRecord.contentId,
                  displayName: displayNameInput
              }});
            }}
              color="primary"
            >
             Save
             {isDisplayNameUpdating ?
              <CircularProgress style={{color: '#fff', marginLeft: '10px'}} size={20} />
              : null}
            </Button>
          </DialogActions>
      </Dialog>
    <div className="options-wrapper" style={{height: `calc(100% - ${titleheight + 8}px)`}}>
      <OptionsButtonsGrid>
        {
          optionsList.map((option: any, index: number) => {
            if(option.type === 'link') {
              return (
                isEditable && !option.isDefault ? <Badge badgeContent={'-'} color="secondary" onClick={() => removeButtonFavorite(option)}>
                    <FavoritesOptionsButton
                      isSelected={selectedButton === option.name}
                      key={index}
                      onClick={(e: any) => onFavoriteButtonClick(e, option)}
                    >
                      {option.name}
                    </FavoritesOptionsButton>
                  </Badge>
                : <FavoritesOptionsButton
                    isSelected={selectedButton === option.name}
                    key={index}
                    onClick={(e: any) => onFavoriteButtonClick(e, option)}
                  >
                    {option.name}
                  </FavoritesOptionsButton>
              );
            } else if(option.type === 'map') {
              return (
                isEditable && !option.isDefault ? <Badge badgeContent={'-'} color="secondary" onClick={() => removeButtonFavorite(option)}>
                    <FavoritesOptionsButton
                      isSelected={selectedButton === option.name}
                      key={index}
                      onClick={() => {setMapType(option.mapType); setSelectedRecordOption(''); setIframeUrl(''); setSelectedButton(option.name);}}
                    >
                      {option.name}
                    </FavoritesOptionsButton>
                  </Badge>
                : <FavoritesOptionsButton
                    isSelected={selectedButton === option.name}
                    key={index}
                    onClick={() => {setMapType(option.mapType); setSelectedRecordOption(''); setIframeUrl(''); setSelectedButton(option.name);}}
                  >
                    {option.name}
                  </FavoritesOptionsButton>
              );
            }

            return (
              isEditable && !option.isDefault ? <Badge badgeContent={'-'} color="secondary" onClick={() => removeButtonFavorite(option)}>
                <FavoritesOptionsButton
                  isSelected={selectedButton === option.name}
                  key={index}
                  onClick={(e: any) => {resetMapHandler(e); setSelectedRecordOption(option.name); setShowCustomizeButtons(false); setIframeUrl(''); setSelectedButton(option.name);}}
                >
                  {option.name}
                </FavoritesOptionsButton>
              </Badge>
              : <FavoritesOptionsButton
                  isSelected={selectedButton === option.name}
                  key={index}
                  onClick={(e: any) => {resetMapHandler(e); setSelectedRecordOption(option.name); setShowCustomizeButtons(false); setIframeUrl(''); setSelectedButton(option.name);}}
                >
                {option.name}
              </FavoritesOptionsButton>
            );
          })
        }
      </OptionsButtonsGrid>
      {getButtonDropDown()}
    </div>
  </RecordOptionsContainer>
  );
};

export default MyTundraFavoriteButtons;
